// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/fuel-injection-principle.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/fuel-injection-principle/fuel-injection-principle.js';

mount([g0]);
